import { PartialSite } from "../models/site";
import axiosConfig from "./axiosConfig";

const postSiteBatteryAnalysis = async (
  authToken: string,
  esysIdx: number | string,
  page: number,
  onlySyntheticBatteries: boolean,
  payload: PartialSite
): Promise<any> => {
  const { data } = await axiosConfig.post(
    `/site/preview/battery_analysis?esysIdx=${esysIdx}&page=${page}&onlySyntheticBatteries=${onlySyntheticBatteries}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postSiteBatteryAnalysis;
